import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useContentAdminPortal } from 'src/core/hooks/useContentAdminPortal';
export default function RenderClubAdmin({ __name, className, ...props }) {
    useContentAdminPortal(__name, props);
    return _jsx("div", { id: __name, className: clsx('ClubAdminApp no-tailwind', className) });
}
